"use client"

import * as React from "react"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./tooltip"
import { classNamesMerge } from "@/utils"

type TooltipPosition = "top" | "bottom" | "left" | "right"

interface SimpleTooltipProps {
  children: React.ReactNode
  title: string | string[]
  position?: TooltipPosition
  delayDuration?: number
  className?: string
  contentClassName?: string
  offsetX?: number
  offsetY?: number
}

const SimpleTooltip = React.forwardRef<
  HTMLDivElement,
  SimpleTooltipProps
>(({ 
  children, 
  title, 
  position = "top", 
  delayDuration = 300,
  className,
  contentClassName = '',
  offsetX = 0,
  offsetY = 0,
  ...props 
}, ref) => {

  const hasContent = (Array.isArray(title) && title.length > 0) || (typeof title === "string" && title.length > 0)

  return hasContent ? (
    <TooltipProvider delayDuration={delayDuration}>
      <Tooltip>
        <TooltipTrigger asChild>
          <div ref={ref} className={className} {...props}>
            {children}
          </div>
        </TooltipTrigger>
        <TooltipContent  
          className={classNamesMerge("px-2 py-2 text-xs rounded-[8px] z-[9999]", contentClassName)} 
          side={position}
          sideOffset={position === "top" || position === "bottom" ? offsetY : offsetX}
          alignOffset={position === "top" || position === "bottom" ? offsetX : offsetY}
        >
          {Array.isArray(title) ? (
            <ul className="list-disc pl-4 space-y-1">
              {title.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          ) : (
            <p>{title}</p>
          )}
        </TooltipContent>        
      </Tooltip>
    </TooltipProvider>
  ) : (
  <>{children}</>
)
})

SimpleTooltip.displayName = "SimpleTooltip"

export { SimpleTooltip, type SimpleTooltipProps, type TooltipPosition }
